import React from 'react';
import AdminCompanyProfileSetupPage from '../components/AdminCompanyProfile/AdminCompanyProfileSetupPage';

const AdminCompanyProfileSetup = () => <AdminCompanyProfileSetupPage />;

export default AdminCompanyProfileSetup;
